import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import apiToken, { handleApiError } from '@/shared/services/axiosInstance';

export const useFindPassword = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await apiToken.post('/api/v1/user/temp-password', {
        email,
      });
      if (response.data.message === 'Temporary password issued successfully.') {
        alert('A temporary password has been sent to your email.');
        navigate('/login');
      }
    } catch (error: any) {
      const errorMessage = handleApiError(error);

      if (error?.response?.data?.message === 'User not found.') {
        alert('User not found. Please check your email address.');
        setEmail('');
        return;
      }

      alert(errorMessage);
      console.error('Failed to issue temporary password:', errorMessage);
    }
  };

  return { email, setEmail, handleSubmit };
};
